/**
 * Stable action names shared by Auto Apply Setup Signals and RUM errors.
 *
 * User-triggered failures use the same value as the originating Signals button.
 * Background operations keep an operation-specific value because they have no button event.
 */
export const AutoApplySetupAction = {
    LookupEntryMode: 'lookup-entry-mode',
    Load: 'load',
    LoadMore: 'load-more',
    Continue: 'continue',
    Activate: 'activate',
    Update: 'update',
    UpdatePreference: 'update-preference',
    UpdateSqPreference: 'update-preference-sq',
    UpdateDqPreference: 'update-preference-dq',
    SaveSqPrefill: 'save-sq-prefill',
    UploadFileResume: 'upload-file-resume',
    EditFreeTextPreferences: 'edit-free-text-preferences',
} as const;

export type AutoApplySetupReviewAction =
    | typeof AutoApplySetupAction.Activate
    | typeof AutoApplySetupAction.Update;
